import { Checkbox, Grid, Table, TableCell, TableRow, TextField, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import loader from '../../common/loader.gif';

function ClauseAndCoverageAfterSI({ rfqDetails, rfqId, sectionId, showCloseOnly = false }) {
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

  const [clauseData, setClauseData] = useState<any>([]);
  const [coverageData, setCoverageData] = useState<any>([]);
  const [selectedClauseIds, setSelectedClauseIds] = useState([]);
  let coverageCount = 0;
  let clauseCount = 0;

  useEffect(() => {
    if (rfqDetails?.policyClauseJSON?.[sectionId]) {
      let clauses = [];
      let coverages = [];

      rfqDetails.policyClauseJSON?.[sectionId].clauses.forEach((clause) => {
        if (clause.checkStatus || clause.mandatory) {
          clauses.push(clause);
        }
      });

      rfqDetails.policyClauseJSON?.[sectionId].coverage.forEach((clause) => {
        if (clause.checkStatus || clause.mandatory) {
          coverages.push(clause);
        }
      });

      setCoverageData(coverages);
      setClauseData(clauses);
    }
  }, [rfqDetails]);



  return (
    <>
      {clauseData.length > 0 || coverageData.length > 0 ? (
        <Table>
          {/* Conditional Rendering for "Coverages Required" Heading */}
          {coverageData.some((clause) => (clause.checkStatus || clause.mandatory)) && !showCloseOnly && (
            <>
              {(rfqDetails['clauseAndCovPosition'] == 'Below-SI' ||
                rfqDetails['clauseAndCovPosition'] == 'Cov-below-SI') && <TableRow>
                  <TableCell className='' colSpan={2} style={{
                    background: '#fff', color: '#000',
                    paddingTop: '2px', paddingBottom: '2px',
                    paddingLeft: '0px',
                    fontWeight: 'bold'
                  }}>
                    REQUESTED TERMS
                  </TableCell>
                </TableRow>}

              {rfqDetails.coverageSectionLabel && <TableRow>
                <TableCell className='left-align-important' colSpan={2} style={{
                  background: '#fff', color: '#000',
                  paddingTop: '2px', paddingBottom: '2px', paddingLeft: '0px'
                }}>
                  {rfqDetails.coverageSectionLabel}
                </TableCell>
              </TableRow>}


              {coverageData.map((clause, index) => {


                return (
                  <React.Fragment key={index}>
                    <TableRow>
                      {
                        (clause.checkStatus || clause.mandatory) && (
                          <TableCell colSpan={2} style={{ padding: 0 }}>
                            <Grid
                              container
                              direction="column"
                              style={{
                                paddingBottom: '2px',
                                borderBottom: '1px solid rgb(46 44 44 / 17%)',
                                position: 'relative',
                                marginTop: '4px',
                              }}
                            >
                              <Grid item>
                                <Stack direction={'row'}>
                                  <Typography variant="h5" style={{ minWidth: '36.3vw', width: '36.3vw', fontWeight: 'normal' }}>
                                    <span style={{ marginRight: '5px' }}>{++coverageCount} )</span>   {clause?.insurenceClause.title}
                                    {clause?.insurenceClause.detailDescription ? ': ' : ''}
                                    <span style={{ marginLeft: '5px', display: 'inline-block' }}>
                                      {clause?.insurenceClause?.detailDescription ? parse(clause?.insurenceClause?.detailDescription) : ''}
                                      {clause?.remarks ? `- ${clause?.remarks}` : ''}
                                    </span>
                                  </Typography>
                                  {/* {clause?.insurenceClause.detailDescription ? ': ' : ''}
                                  <span style={{ marginLeft: '5px', display: 'inline-block', width: '60%' }}>  {clause?.insurenceClause?.detailDescription ? parse(clause?.insurenceClause?.detailDescription) : ''}
                                    {clause?.remarks ? `- ${clause?.remarks}` : ''}
                                  </span> */}
                                </Stack>

                              </Grid>

                            </Grid>
                          </TableCell>
                        )}
                    </TableRow>
                  </React.Fragment>
                )
              })}

            </>
          )}

          {/* Conditional Rendering for "Clauses Required" Heading */}
          {clauseData.some((clause) => (clause.checkStatus || clause.mandatory)) && (rfqDetails['clauseAndCovPosition'] != 'Cov-below-SI' || showCloseOnly) && (
            <>
              {rfqDetails.clauseSectionLabel && <TableRow>
                <TableCell className='left-align-important ' colSpan={2} style={{
                  background: '#fff', color: '#000',
                  paddingTop: '2px', paddingBottom: '2px', paddingLeft: '0px'
                }}>
                  {rfqDetails.clauseSectionLabel}
                </TableCell>
              </TableRow>}



              {clauseData.map((clause, index) => (

                <React.Fragment key={index}>
                  <TableRow>
                    {
                      (clause.checkStatus || clause.mandatory) && (
                        <TableCell colSpan={2} style={{ padding: 0 }}>
                          <Grid
                            container
                            direction="column"
                            style={{
                              paddingBottom: '2px',
                              borderBottom: '1px solid rgb(46 44 44 / 17%)',
                              position: 'relative',
                              marginTop: '4px',
                            }}
                          >
                            <Grid item>
                              <Stack direction={'row'}>
                                <Typography variant="h5" style={{ width: '36.3vw', fontWeight: 'normal' }}>
                                  <span style={{ marginRight: '5px' }}>{++clauseCount} )</span> {clause?.insurenceClause.title}
                                  {clause?.insurenceClause.detailDescription ? ': ' : ''}
                                  <span style={{ marginLeft: '5px', display: 'inline-block' }}>
                                    {clause?.insurenceClause?.detailDescription ? parse(clause?.insurenceClause?.detailDescription) : ''}
                                    {clause?.remarks ? `- ${clause?.remarks}` : ''}
                                  </span>
                                </Typography>
                                {/* {clause?.insurenceClause.detailDescription ? ': ' : ''}
                                <span style={{ marginLeft: '5px', display: 'inline-block', width: '60%' }}>{clause?.insurenceClause?.detailDescription ? parse(clause?.insurenceClause?.detailDescription) : ''}
                                  {clause?.remarks ? `- ${clause?.remarks}` : ''}
                                </span> */}
                              </Stack>
                            </Grid>

                          </Grid>
                        </TableCell>
                      )}
                  </TableRow>
                </React.Fragment>
              ))}

            </>
          )}
        </Table>
      ) : null}
    </>

  );
}

export default ClauseAndCoverageAfterSI;
